import {Login} from './Login'
import {useEffect} from 'react';
import {getSession} from '../api/Api';

export const Auth = ({authorized, onComplete, onFail, children}) => {
    useEffect(() => {
        getSession().then(r => {
            onComplete(r);
        }).catch(e => {
            // no session, just catch the errors here
        });
    }, [onComplete])
    const page = authorized ? {...children} : <div><Login onSuccessfulLogin={onComplete} onFailedLogin={onFail} /></div>

    return page;
}